import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { CalendarClock, CheckCircle2 } from "lucide-react";

export default function PortalSprays() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/portal/sprays").then(({ data }) => setData(data)); }, []);
  if (!data) return <div className="p-6 font-bold uppercase text-sm">Loading spray records…</div>;

  const reiActive = (a) => a.rei_until && new Date(a.rei_until) > new Date();

  return (
    <div className="space-y-5" data-testid="portal-sprays">
      <div>
        <div className="font-bold uppercase text-xs text-stone-500 flex items-center gap-1.5 mb-2"><CalendarClock size={14} /> Scheduled / Upcoming</div>
        <div className="space-y-2">
          {data.upcoming.map((o) => (
            <div key={o.wo_number} data-testid={`portal-spray-upcoming-${o.wo_number}`} className="bg-white border border-stone-200 p-4">
              <div className="flex flex-wrap items-center gap-2">
                <span className="font-mono font-bold">{o.wo_number}</span>
                <span className="text-[10px] font-bold uppercase px-2 py-0.5 bg-amber-200 text-amber-900">{o.status === "approved" ? "Scheduled" : "In Review"}</span>
                <span className="text-sm text-stone-500">{o.target}</span>
              </div>
              <div className="text-xs text-stone-600 mt-1">
                {o.date ? `${o.date}${o.planned_start ? ` · ${o.planned_start}` : ""} · ` : ""}{o.vineyard_name} · {o.blocks.join(", ")} · {o.treated_acres} ac{o.reason ? ` · ${o.reason}` : ""}
              </div>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {o.products.map((p, i) => (
                  <span key={i} className="text-[11px] font-semibold bg-stone-100 border border-stone-200 px-2 py-1">
                    {p.product} · {p.rate} {p.rate_unit}{p.rei_hours != null ? ` · REI ${p.rei_hours}h` : ""}{p.phi_days != null ? ` · PHI ${p.phi_days}d` : ""}
                  </span>
                ))}
              </div>
            </div>
          ))}
          {data.upcoming.length === 0 && (
            <div className="bg-white border border-stone-200 p-6 text-center text-stone-400 font-bold uppercase text-xs" data-testid="portal-sprays-upcoming-empty">No sprays scheduled on your blocks</div>
          )}
        </div>
      </div>

      <div>
        <div className="font-bold uppercase text-xs text-stone-500 flex items-center gap-1.5 mb-2"><CheckCircle2 size={14} /> Completed Applications</div>
        <div className="bg-white border border-stone-200 overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-[#1F3D34] text-white text-left text-[10px] uppercase">
                <th className="p-3">Date</th><th className="p-3">Product</th><th className="p-3">Target</th>
                <th className="p-3">Blocks</th><th className="p-3 text-right">Rate</th><th className="p-3">REI</th><th className="p-3">PHI</th>
              </tr>
            </thead>
            <tbody>
              {data.completed.map((a, i) => (
                <tr key={i} data-testid={`portal-spray-completed-${i}`} className="border-t border-stone-200">
                  <td className="p-3 font-mono">{a.date}</td>
                  <td className="p-3 font-bold">{a.product}</td>
                  <td className="p-3">{a.target}</td>
                  <td className="p-3 text-xs">{a.ranch_number} · {a.blocks.join(", ")}</td>
                  <td className="p-3 text-right">{a.rate} {a.rate_unit}</td>
                  <td className="p-3 text-xs">
                    {a.rei_hours != null ? `${a.rei_hours}h` : "—"}
                    {reiActive(a) && <span className="ml-1 text-[9px] font-bold uppercase bg-red-100 text-red-700 px-1.5 py-0.5">Re-entry restricted</span>}
                  </td>
                  <td className="p-3 text-xs">{a.phi_days != null ? `${a.phi_days}d` : "—"}</td>
                </tr>
              ))}
              {data.completed.length === 0 && (
                <tr><td colSpan={7} className="p-8 text-center text-stone-400 font-bold uppercase text-xs" data-testid="portal-sprays-completed-empty">No completed applications on your blocks yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
